/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-14 17:34:37
 * @Description  : 跟平台相关的判断
 */
import { constConf } from '@GLOBAL/constConf';

const { IS_LOCAL, ORIGIN_PATHNAME, PROJECT } = constConf

const UA = navigator.userAgent || '';
// 马甲包重定向正则,命名需要按照这种规范,会涉及到替换命令
const APP_REG = '(oxygen|caramel|callme|neon|hydrogen|yoyo|bantang|memoryDiary|yes)'
const isOxygen = /oxygen/i.test(UA)
const isCaramel = /caramel/i.test(UA)
const isCallme = /callme/i.test(UA)
const isPopo = /callme/i.test(UA)
const isYes = /yes[^P]/i.test(UA)
const isYoyo = /yoyo[^P]/i.test(UA)
const isBantang = /bantang[^P]/i.test(UA)
const isMemoryDiary = /memoryDiary[^P]/i.test(UA)
const isNeon = /neon[^P]/i.test(UA)
const isYesPC = /yesPc/i.test(UA)
const isYoyoPC = /yoyoPc/i.test(UA)
const isBantangPC = /bantangPc/i.test(UA)
const isMemoryDiaryPC = /memoryDiaryPc/i.test(UA)
const isOxygenPC = /PCMiz/i.test(UA)
const isCaramelPC = /PCMiz/i.test(UA)
const isCallmePC = /PCMiz/i.test(UA)
const isPopoPC = /PCMiz/i.test(UA)
const isFlutter = isYes || isYoyo || isBantang || isMemoryDiary
const isApp = isOxygen || isCaramel || isCallme || isYes || isYoyo || isBantang || isMemoryDiary || isNeon
const isPc = isOxygenPC || isCaramelPC || isCallmePC || isYesPC || isYoyoPC || isBantangPC || isMemoryDiaryPC || isPopoPC
const isClient = isApp || isPc
const isOxygenSeries = isOxygen || isCaramel || isCallme

export const client = {
  isFlutter,
  isOxygen,
  isCaramel,
  isCallme,
  isPopo,
  isYes,
  isYoyo,
  isBantang,
  isMemoryDiary,
  isNeon,
  isYesPC,
  isYoyoPC,
  isBantangPC,
  isMemoryDiaryPC,
  isOxygenPC,
  isCaramelPC,
  isCallmePC,
  isPopoPC,
  isApp,
  isPc,
  isClient,
  isOxygenSeries
};

// 是否是氧气系列 通过project判断 兼容站外情况
export const isOxygenFolderSeries = /(oxygen|caramel|callme)/i.test(PROJECT)

/**
 * @description: 因为服务端下发或者一些后台配置默认是用写死的主包地址(常见的活动,青少年,公会邀请等),在这些页面需要在入口处执行自动识别重定向到正确路径,但是域名无法修正,部分华为,荣耀不支持站内充值需要主动打开站外浏览器
 * 这方法需要确保的bridge初始化完成后才能执行
 * @param      {*} targetUrl 重定向地址,可选
 * @return     {*}
 */
export function appRedirect(targetUrl = ORIGIN_PATHNAME) {
  // 本地运行和站外不需要执行
  if (IS_LOCAL || !isApp) return;

  const href = location.href;
  /* // 充值页需重定向
  const isRecharge = /\/recharge\//g.test(href);
  const needTransfer = isOxygen || isCaramel || isYes

  // 暂时华为都跳出去
  if (isRecharge && needTransfer && (browser.isHuaweiDevice || browser.isHonorDevice)) {
    openBrowser(targetUrl)
    close()
    return
  } */

  // 站内UA路径替换
  const isMatchUA = navigator.userAgent.match(new RegExp(APP_REG));
  const isMatchURL = href.match(new RegExp(`/${APP_REG}/`));
  // 不匹配中断
  if (isMatchUA !== null && isMatchURL !== null) {
    // 匹配自动重定向
    const productUA = isMatchUA[0];
    const productURL = isMatchURL[1];
    if (productUA !== productURL) {
      const url = href.replace(isMatchURL[0], `/${productUA}/`);
      // 半糖重定向过快会出现解析异步组件路由失败的错误,原因未知
      setTimeout(() => {
        location.replace(url);
      });
    }
  }
}
